import { Plus } from 'lucide-react'
import { useState } from 'react'
import useSWR from 'swr'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { Skeleton } from '@/components/ui/skeleton'
import { UsersTable } from '@/components/UsersTable/UsersTable'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { InviteUserForm } from '@/forms/InviteUserForm/InviteUserForm'
import { Collection } from '@/interfaces/Collection'
import { User } from '@/types/User'

export default function SettingsUsersPage() {
  const [open, setOpen] = useState(false)

  const { data: users, isLoading, mutate } = useSWR<Collection<User>>('/api/v2/users', apiFetcher)

  return (
    <SettingsPage
      title="Uživatelé"
      description="Kdo má do účtu přístup. Nový uživatel dostane pozvánku e-mailem."
      breadcrumbHref="/settings/users"
      width="list"
      actions={
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button>
              <Plus />
              Přidat uživatele
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Přidat uživatele</DialogTitle>
              <DialogDescription>Novému uživateli pošleme e-mail s pozvánkou.</DialogDescription>
            </DialogHeader>
            <InviteUserForm
              onSuccess={() => {
                mutate()
                setOpen(false)
              }}
            />
          </DialogContent>
        </Dialog>
      }
    >
      {isLoading && (
        <div className="space-y-2 rounded-lg border p-4">
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-1/3" />
        </div>
      )}

      {users && <UsersTable users={users.data} refresh={() => mutate()} />}

      <section className="mt-6 rounded-lg bg-muted/70 p-4 sm:p-5">
        <h2 className="mb-3 text-[13px] font-medium">Co která role může</h2>
        <dl className="grid gap-x-6 gap-y-2.5 text-sm sm:grid-cols-[140px_1fr]">
        <dt className="font-medium">Vlastník</dt>
        <dd className="text-muted-foreground">Má přístup ke všemu. Vlastníka nejde smazat.</dd>
        <dt className="font-medium">Správce</dt>
        <dd className="text-muted-foreground">Vidí všechna nastavení a doklady a může přidávat zaměstnance a účetní.</dd>
        <dt className="font-medium">Zaměstnanec</dt>
        <dd className="text-muted-foreground">Vytváří a upravuje doklady, nastavení měnit nemůže.</dd>
        <dt className="font-medium">Účetní</dt>
        <dd className="text-muted-foreground">Vidí doklady a banku, ale nic nemění.</dd>
        </dl>
      </section>
    </SettingsPage>
  )
}
